// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ikbS","col":"styles_col__3UxDO","actions":"styles_actions__216RR","conflict":"styles_conflict__3oDbG"};